// extracted by mini-css-extract-plugin
export default {"cls1":"FilterContainer-Container_cls1__3F6og","cls2":"FilterContainer-Container_cls2__fmx91 FilterContainer-Container_cls1__3F6og"};